import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import type { Feature } from 'geojson';

/**
 * Manages AOI feature detail dialogs triggered by map clicks on pipeline AOI POI features.
 * Mirrors PipelineEmbeddingsPanelService — no floating panel, only individual feature dialogs.
 */
@Injectable({ providedIn: 'root' })
export class PipelineAoiPanelService {
  /** Emits when a single AOI feature should be shown in a detail dialog. */
  readonly featureDetailTrigger$ = new Subject<Feature>();

  /** Triggers a detail dialog for the given AOI feature. */
  openFeatureDetail(feature: Feature): void {
    this.featureDetailTrigger$.next(feature);
  }
}
